import { FC, ReactNode, createElement } from 'react';
import { AnimatePresence } from 'framer-motion';
export interface CbAnimationEnterExitProps {
  animate: boolean;
  enterComponent?: FC;
  exitComponent?: FC;
  enterContent?: ReactNode;
  exitContent?: ReactNode;
  initial?: boolean;
  children?: ReactNode;
}
export const CbAnimationEnterExit: FC<CbAnimationEnterExitProps> = ({
  animate,
  enterComponent,
  exitComponent,
  enterContent,
  exitContent,
  initial,
  children
}) => {
  const enter = enterContent || enterComponent && createElement(enterComponent) || children;
  const exit = exitContent || exitComponent && createElement(exitComponent) || children;
  return <AnimatePresence initial={initial} data-sentry-element="AnimatePresence" data-sentry-component="CbAnimationEnterExit" data-sentry-source-file="CbAnimationEnterExit.tsx">
      {animate && enter}
      {!animate && exit}
    </AnimatePresence>;
};